import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import Layout from './components/Layout';
import ReportsPage from './pages/ReportsPage';
import DashboardPage from './pages/ReportDashboardPage';
import DrillDownPage from './pages/DrillDownPage';
import DocumentDetailPage from './pages/DocumentDetailPage';
// import ChatPage from './pages/ChatPage';
import NotFound from './components/NotFound';
import ErrorFallback from './components/ErrorFallback';
import { ToastProvider } from './contexts/ToastContext';
import ToastContainer from './components/ToastContainer';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
// import SettingsPage from './pages/SettingsPage';
import AuthErrorHandler from './components/AuthErrorHandler';
import './App.css';

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <AuthProvider>
        <ToastProvider>
          <AuthErrorHandler>
            <Router>
              <ProtectedRoute>
                <div className="App">
                  <ToastContainer />
                  <Routes>
                    <Route path="/" element={<Layout />}>
                      <Route index element={<DashboardPage />} />
                      <Route path="dashboard" element={<DashboardPage />} />
                      <Route path="dashboard/drill-down" element={<DrillDownPage />} />
                      <Route path="dashboard/reports" element={<ReportsPage />} />
                      <Route path="document/:id" element={<DocumentDetailPage />} />
                      {/* <Route path="chat" element={<ChatPage />} /> */}
                      {/* <Route path="settings" element={<SettingsPage />} /> */}
                      <Route path="*" element={<NotFound />} />
                    </Route>
                  </Routes>
                </div>
              </ProtectedRoute>
            </Router>
          </AuthErrorHandler>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;